import React, { PureComponent } from "react";
import { Button } from "react-bootstrap";
import { bootstrapUtils } from "react-bootstrap/lib/utils";
import FontAwesome from "react-fontawesome";
import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest
} from "../../api/ApiService";
import AddCourseModal from "../components/add-course-modal";
import EditCourseModal from "../components/edit-course-modal";
import IASCourseModal from "../components/ias-course-modal";
import StudentCourseModal from "../components/student-course-modal";

bootstrapUtils.addStyle(Button, "light-blue");

const COURSES_LIST_API = `${process.env.REACT_APP_API_URL}courses/`;
const COURSE_MEMBERS_LIST_API = `${process.env.REACT_APP_API_URL}course_members/`;

const IAS_ROLE = 2;
const STUDENT_ROLE = 1;

class CourseManagement extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      courses: [],
      course_members: [],
      courses_loaded: false,
      course_members_loaded: false,
      addModalShown: false,
      editModalShown: false,
      iasModalShown: false,
      studentModalShown: false,
      current_course: null
    };
  }

  componentWillMount() {
    this.fetchCourses();
    this.fetchCourseMembers();
  }

  fetchCourses = () => {
    getRequest(COURSES_LIST_API)
      .then(res => {
        this.setState({
          courses: res.body,
          courses_loaded: true
        });
      })
      .catch(err => {});
  };

  fetchCourseMembers = () => {
    getRequest(COURSE_MEMBERS_LIST_API)
      .then(res => {
        this.setState({
          course_members: res.body,
          course_members_loaded: true
        });
      })
      .catch(err => {});
  };

  countAssistents = course => {
    const { course_members } = this.state;
    const assistents = course_members.filter(
      course_member =>
        course_member.course === course.id &&
        course_member.type === IAS_ROLE &&
        course.users.includes(course_member.user)
    );

    return assistents.length;
  };

  countStudents = course => {
    const { course_members } = this.state;
    const students = course_members.filter(
      course_member =>
        course_member.course === course.id &&
        course_member.type === STUDENT_ROLE &&
        course.users.includes(course_member.user)
    );

    return students.length;
  };

  showAddModal = () => {
    this.setState({
      addModalShown: true
    });
  };

  hideAddModal = () => {
    this.setState({
      addModalShown: false
    });
  };

  showEditModal = () => {
    this.setState({
      editModalShown: true
    });
  };

  hideEditModal = () => {
    this.setState({
      editModalShown: false,
      current_course: null
    });
  };

  showIASModal = () => {
    this.setState({
      iasModalShown: true
    });
  };

  hideIASModal = () => {
    this.setState({
      iasModalShown: false,
      current_course: null
    });
  };

  showStudentModal = () => {
    this.setState({
      studentModalShown: true
    });
  };

  hideStudentModal = () => {
    this.setState({
      studentModalShown: false,
      current_course: null
    });
  };

  addCourse = (course_name, callback) => {
    postRequest(COURSES_LIST_API)
      .send({
        name: course_name
      })
      .then(res => {
        callback();
        this.fetchCourses();

        this.setState({
          addModalShown: false
        });
      })
      .catch(err => {});
  };

  editCourse = (course_name, callback) => {
    const { current_course } = this.state;

    putRequest(`${COURSES_LIST_API}${current_course.id}/`)
      .send({
        name: course_name
      })
      .then(res => {
        callback();
        this.fetchCourses();

        this.setState({
          editModalShown: false,
          current_course: null
        });
      })
      .catch(err => {});
  };

  deleteCourse = (e, course_id) => {
    e.preventDefault();

    const { courses } = this.state;
    const course = courses.find(i => i.id === course_id);
    const course_name = course ? course.name : "";

    if (window.confirm(`Are sure to delete course "${course_name}"?`)) {
      deleteRequest(`${COURSES_LIST_API}${course_id}/`)
        .then(res => {
          this.fetchCourses();
        })
        .catch(err => {});
    }
  };

  editCourseModal = (e, course_id) => {
    e.preventDefault();

    const { courses } = this.state;
    const course = courses.find(i => i.id === course_id);

    if (course) {
      this.setState(
        {
          current_course: course
        },
        () => {
          this.showEditModal();
        }
      );
    }
  };

  initIASCourseModal = (e, course_id) => {
    e.preventDefault();

    const { courses } = this.state;
    const course = courses.find(i => i.id === course_id);

    if (course) {
      this.setState(
        {
          current_course: course
        },
        () => {
          this.showIASModal();
        }
      );
    }
  };

  initStudentCourseModal = (e, course_id) => {
    e.preventDefault();

    const { courses } = this.state;
    const course = courses.find(i => i.id === course_id);

    if (course) {
      this.setState(
        {
          current_course: course
        },
        () => {
          this.showStudentModal();
        }
      );
    }
  };

  render() {
    const {
      courses,
      courses_loaded,
      course_members_loaded,
      addModalShown,
      editModalShown,
      iasModalShown,
      studentModalShown,
      current_course
    } = this.state;

    return (
      <section className="instructorPage">
        <h1>Courses</h1>
        <div className="instructorWrapper">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th className="text-center instructor-table-th">No.</th>
                  <th className="text-center instructor-table-th">
                    Course Name
                  </th>
                  <th className="text-center instructor-table-th">
                    Course Code
                  </th>
                  <th className="text-center instructor-table-th">
                    Instructor Assistants
                  </th>
                  <th className="text-center instructor-table-th">Students</th>
                </tr>
              </thead>
              <tbody>
                {(courses_loaded === false ||
                  course_members_loaded === false) && (
                  <tr>
                    <td
                      colSpan={5}
                      className="text-center v-align-middle instructor-td"
                    >
                      Loading...
                    </td>
                  </tr>
                )}
                {courses_loaded === true &&
                  course_members_loaded === true &&
                  courses.map((course, counter) => (
                    <tr key={counter}>
                      <td className="text-center v-align-middle instructor-round-number b-r">
                        {counter + 1}
                      </td>
                      <td className="text-center v-align-middle b-l b-r instructor-td">
                        {course.name}
                        <a
                          href="/#"
                          onClick={e => this.editCourseModal(e, course.id)}
                          className="no-outline"
                        >
                          <FontAwesome
                            className="instructor-edit"
                            name="edit"
                          />
                        </a>
                        <a
                          href="/#"
                          onClick={e => this.deleteCourse(e, course.id)}
                          className="no-outline"
                          style={{ display: "none" }}
                        >
                          <FontAwesome
                            className="instructor-edit"
                            name="trash-o"
                          />
                        </a>
                      </td>
                      <td className="text-center v-align-middle b-l b-r instructor-td">
                        {course.code}
                      </td>
                      <td className="text-center v-align-middle b-l b-r instructor-td">
                        {this.countAssistents(course)}
                        <a
                          href="/#"
                          onClick={e => this.initIASCourseModal(e, course.id)}
                          className="no-outline"
                        >
                          <FontAwesome
                            className="instructor-edit"
                            name="edit"
                          />
                        </a>
                      </td>
                      <td className="text-center v-align-middle b-l instructor-td">
                        {this.countStudents(course)}
                        <a
                          href="/#"
                          onClick={e =>
                            this.initStudentCourseModal(e, course.id)
                          }
                          className="no-outline"
                        >
                          <FontAwesome
                            className="instructor-edit"
                            name="edit"
                          />
                        </a>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          {courses.length < 3 && (
            <div className="bottom-button">
              <Button
                bsStyle="light-blue"
                onClick={this.showAddModal}
                block={true}
              >
                Add
              </Button>
            </div>
          )}
        </div>
        <AddCourseModal
          show={addModalShown}
          onHide={this.hideAddModal}
          addCourse={this.addCourse}
        />
        <EditCourseModal
          show={editModalShown}
          onHide={this.hideEditModal}
          editCourse={this.editCourse}
          currentCourse={current_course}
        />
        <IASCourseModal
          show={iasModalShown}
          onHide={this.hideIASModal}
          currentCourse={current_course}
          fetchData={this.fetchCourseMembers}
        />
        <StudentCourseModal
          show={studentModalShown}
          onHide={this.hideStudentModal}
          currentCourse={current_course}
        />
      </section>
    );
  }
}

export default CourseManagement;



// WEBPACK FOOTER //
// ./src/instructor/containers/course-management.js